<template>

    <nav class="c-tabs_nav">
        <ul class="c-tabs_nav-list">
            <li
                v-for="(tabItem, tab_index) in tabItems"
                :key="tab_index"
                class="c-tabs_nav-item">
                <a
                    class="c-tabs_nav-link"
                    :class="{
            'active' : tabItem.isActive,
            'disabled': tabItem.disabled,
            'completed' : tabItem.isCompleted || tabItem.allSectionsSaved,
            'has-empty' : tabItem.hasEmpty && tabItem.allSectionsSaved,
            'error' : tabItem.hasErrors
          }"
                    @click="tabClick(tab_index)">
                    {{ tabItem.title }}
                </a>
                <ul
                    v-show="tabItem.tabSections"
                    class="c-tabs_nav-sublist"
                    :class="{ 'c-tabs_nav-sublist--open' : tabItem.isActive }">
                    <li
                        v-for="(tabSection, s_index) in tabItem.tabSections"
                        :key="s_index"
                        class="c-tabs_nav-subitem">
            <span
                class="c-tabs_nav-sublink"
                :class="{
                'filled' : tabSection.saved,
                'empty': tabSection.empty
              }"
                @click="tabItem.navigateToSection(s_index)">
              {{ tabSection.title }}
            </span>
                    </li>
                </ul>
            </li>
        </ul>
        <v-btn
            class="c-tabs_nav__end"
            v-if="endBtnLabel"
            type="green"
            @click="$parent.$emit('submit')">
            {{ endBtnLabel }}
        </v-btn>
        <p>{{ endBtnHint }}</p>
    </nav>

</template>


<script>

import VBtn from 'Components/VBtn'

export default {

    name: 'TabsNav',

    props: {
        endBtnLabel: String,
        endBtnHint: String
    },

    data() {
        return {
            tabItems: this.$parent.tabItems || []
        }
    },

    methods: {
        changeTab(newIndex) {
            if (this.$parent.activeTab === newIndex) return

            this.tabItems[this.$parent.activeTab].deactivate(this.$parent.activeTab, newIndex)
            this.tabItems[newIndex].activate(this.$parent.activeTab, newIndex)
            this.$parent.activeTab = newIndex
            this.$emit('change', newIndex)
        },
        tabClick(value) {
            this.$emit('input', value)
            this.changeTab(value)
        }
    },

    components: {
        VBtn
    }

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-tabs_nav {
    padding: 50px 20px 50px 50px;
    width: 400px;
    flex-shrink: 0;

    &-list {
        width: 100%;
        max-width: 330px;
        margin: -7px 0;
    }
    &-item {
        position: relative;
        width: 100%;
        padding: 7px 30px 7px 0px;
    }
    &-link {
        text-transform: uppercase;
        color: $c-third;
        font-weight: bold;
        cursor: pointer;
        transition: color .3s ease-in-out;

        &.error:before,
        &.completed:before,
        &.has-empty:before {
            content: '';
            position: absolute;
            top: 5.5px;
            right: 0;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            background-position: center;
            background-repeat: no-repeat;
        }
        &.completed:before {
            z-index: 1;
            background-color: $c-success;
            background-image: url('#{$icons}/tick.svg');
            background-size: 13px 10px;
        }
        &.has-empty:before {
            z-index: 1;
            background-color: $c-warning;
            background-image: url('#{$icons}/tick.svg');
            background-size: 13px 10px;
        }
        &.error:before {
            z-index: 2;
            background-color: $c-red;
            background-image: url('#{$icons}/error1.svg');
            background-size: 13px 13px;
        }
        &.active {
            color: $c-primary;
        }
    }
    &-sublist {
        overflow: hidden;
        transition: max-height .3s cubic-bezier(.32, .14, .25, 1);
        max-height: 0px;
        line-height: 1.25;

        &--open {
            max-height: 500px;
        }
    }
    &-subitem {
        margin: 8px 0;
    }
    &-sublink {
        display: inline-block;
        position: relative;
        padding-left: 20px;
        color: $c-text;
        cursor: pointer;

        &:before {
            content: '';
            position: absolute;
            top: 9px;
            left: 0;
            width: 13px;
            height: 2px;
            background-color: $c-border;
        }
        &.filled:before {
            background-color: $c-primary;
        }
        &.empty:before {
            background-color: $c-warning;
        }
    }
    @include bp($screen-xl) {
        width: 100%;
    }
    @include bp($screen-sm) {
        padding: 40px 20px 20px 20px;

        &-list {
            max-width: 100%;
        }
    }
    &__end {
        margin-top: 1rem;
    }
}

</style>
